import { heDecodeOrDefault } from "~/lib/shared/html-utils";
import { getRouteFromPostType } from "~/lib/shared/getRouteFromPostType";
import { RelatedStoryContentBlock } from "~/types/asgard/PostContentBlock";
import { RelatedStoryCardProps } from "./RelatedStoryCard";

export const apiToRelatedStoryCardProps = (
  apiData: RelatedStoryContentBlock
): RelatedStoryCardProps => ({
  headline: heDecodeOrDefault(apiData.related_story.post_title),
  href: getRouteFromPostType(
    apiData.related_story.post_type,
    apiData.related_story.post_name
  ),
});
